import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../theme';
import { useCallback } from 'react';

interface Props {
	className?: string;
	target?: string;
	noUderline?: boolean;
	action?: string | React.MouseEventHandler;
	dataTestId?: string;
}

const Link: React.FunctionComponent<Props> = ({ action, className, children, target, noUderline, dataTestId }) => {
	const { Link: css } = useTheme('Link');

	const onClick =
		typeof action === 'function'
			? useCallback(
					(e: React.MouseEvent) => {
						e.preventDefault();
						action(e);
					},
					[action]
			  )
			: null;

	return (
		<a
			target={target}
			className={cn(css.link, className, {
				[css.link_noUnderline]: noUderline
			})}
			href={typeof action === 'string' ? action : '#'}
			onClick={onClick}
			data-test-id={dataTestId}
		>
			{children}
		</a>
	);
};

export default Link;
